import { FieldValidationError } from '../../../types/form/field-validation-error';
import { getRegexFormatValidationRule } from './regex-format-validation-rule';
export const getNumberRangeValidationRule = (rangeDefinition) => {
    return data => {
        const value = parseFloat(data);
        const { min, max } = rangeDefinition;
        if (isNaN(value))
            return;
        if (min !== undefined && value < min) {
            return FieldValidationError.Range;
        }
        if (max !== undefined && value > max) {
            return FieldValidationError.Range;
        }
    };
};
const decimalRegex = /^-?\d+(\.\d*)?$/i;
export const decimalValidationRule = getRegexFormatValidationRule(decimalRegex);
const integerRegex = /^-?\d+$/i;
export const integerValidationRule = getRegexFormatValidationRule(integerRegex);
//# sourceMappingURL=number-validation-rule.js.map